import { z } from 'zod';

export const PLACE_FISCAL_PROCESSOR_SYNC_STATUSES = [
  'NOT_SYNCED',
  'PENDING',
  'SYNCED',
  'FAILED',
] as const;

export const UpsertPlaceCertificatePasswordBodySchema = z.looseObject({
  password: z.string().min(1).max(256),
});
export type UpsertPlaceCertificatePasswordBody = z.infer<
  typeof UpsertPlaceCertificatePasswordBodySchema
>;

export const UpsertPlaceNfceCscBodySchema = z.looseObject({
  nfceTokenId: z.string().min(1).max(32),
  csc: z.string().min(1).max(64),
});
export type UpsertPlaceNfceCscBody = z.infer<typeof UpsertPlaceNfceCscBodySchema>;

export const PlaceFiscalSecretsFlagsResponseSchema = z.looseObject({
  placeId: z.uuid(),
  hasCertificatePassword: z.boolean(),
  hasNfceCsc: z.boolean(),
  nfceTokenId: z.string().nullable(),
});
export type PlaceFiscalSecretsFlagsResponse = z.infer<typeof PlaceFiscalSecretsFlagsResponseSchema>;

export const SyncPlaceIssuerConfigResponseSchema = z.looseObject({
  placeId: z.uuid(),
  syncVersion: z.number().int().nonnegative(),
  status: z.enum(PLACE_FISCAL_PROCESSOR_SYNC_STATUSES),
});
export type SyncPlaceIssuerConfigResponse = z.infer<typeof SyncPlaceIssuerConfigResponseSchema>;

export const GetPlaceIssuerSyncStatusResponseSchema = z.looseObject({
  placeId: z.uuid(),
  syncVersion: z.number().int().nonnegative(),
  status: z.enum(PLACE_FISCAL_PROCESSOR_SYNC_STATUSES),
  processorSyncedVersion: z.number().int().nonnegative(),
  lastErrorCode: z.string().nullable(),
  lastErrorMessage: z.string().nullable(),
  lastSyncedAt: z.iso.datetime().nullable(),
  hasCertificatePassword: z.boolean(),
  hasNfceCsc: z.boolean(),
  nfceTokenId: z.string().nullable(),
  dfe: z
    .looseObject({
      syncVersion: z.number().int().nonnegative(),
      status: z.enum(PLACE_FISCAL_PROCESSOR_SYNC_STATUSES),
      processorSyncedVersion: z.number().int().nonnegative(),
      lastErrorCode: z.string().nullable(),
      lastErrorMessage: z.string().nullable(),
      lastSyncedAt: z.iso.datetime().nullable(),
      distributionInitialNsu: z.string().nullable(),
    })
    .optional(),
  nfse: z
    .looseObject({
      syncVersion: z.number().int().nonnegative(),
      status: z.enum(PLACE_FISCAL_PROCESSOR_SYNC_STATUSES),
      processorSyncedVersion: z.number().int().nonnegative(),
      lastErrorCode: z.string().nullable(),
      lastErrorMessage: z.string().nullable(),
      lastSyncedAt: z.iso.datetime().nullable(),
    })
    .optional(),
});
export type GetPlaceIssuerSyncStatusResponse = z.infer<
  typeof GetPlaceIssuerSyncStatusResponseSchema
>;

export const SyncPlaceDfeIssuerConfigResponseSchema = z.looseObject({
  placeId: z.uuid(),
  syncVersion: z.number().int().nonnegative(),
  status: z.enum(PLACE_FISCAL_PROCESSOR_SYNC_STATUSES),
});
export type SyncPlaceDfeIssuerConfigResponse = z.infer<
  typeof SyncPlaceDfeIssuerConfigResponseSchema
>;

export const SyncPlaceNfseIssuerConfigResponseSchema = z.looseObject({
  placeId: z.uuid(),
  syncVersion: z.number().int().nonnegative(),
  status: z.enum(PLACE_FISCAL_PROCESSOR_SYNC_STATUSES),
});
export type SyncPlaceNfseIssuerConfigResponse = z.infer<
  typeof SyncPlaceNfseIssuerConfigResponseSchema
>;

export const UpsertPlaceDfeDistributionInitialNsuBodySchema = z.looseObject({
  distributionInitialNsu: z.string().min(1).max(15),
});
export type UpsertPlaceDfeDistributionInitialNsuBody = z.infer<
  typeof UpsertPlaceDfeDistributionInitialNsuBodySchema
>;

export const PlaceDfeDistributionInitialNsuResponseSchema = z.looseObject({
  placeId: z.uuid(),
  distributionInitialNsu: z.string().nullable(),
});
export type PlaceDfeDistributionInitialNsuResponse = z.infer<
  typeof PlaceDfeDistributionInitialNsuResponseSchema
>;
